module.exports = __webpack_public_path__ + "static/bg-sec4-sm-b569cc5e1a20bc610081a9ce167dcf8b.jpg";